<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('attendanceAbsenceNotification.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('attendanceAbsenceNotification.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input v-model="search" :placeholder="$t('attendanceAbsenceNotification.searchPlaceholder')
              " v-tooltip="$t('attendanceAbsenceNotification.searchPlaceholder')" style="width: 250px"
              class="inline-block" />
            <ts-button outline class="ml-2" v-tooltip="$t('invoice.filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
          <filter-drawer :visible="visible" :branch-id="branch_id" :filters="filters" :branches="branchs"
            :academic-years="academicYears" :main-programs="mainPrograms" :sub-programs="subPrograms"
            :academic-terms="academicTerms" :warning-levels="warningLevels"  :loading="filterLoading" v-on:update:branch-id="changeBranchFilter"
            v-on:update:filters="filters = $event" v-on:clear="clearFilters" v-on:cancel="cancelFilters"
            v-on:apply="applyFilters" />
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{ field: 'class_name' }">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.branch_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.card_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.student_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.gender }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.term_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.session }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.absence_count }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.last_absent_date }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span :class="warningLevelClass(record.warning_level)">
                {{ record.notification_type }}
              </span>
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.teacher_name }}</td>
            <td class="ts-whitespace-no-wrap parent-phone-cell">
              <div v-if="record.father_phone" class="parent-phone-line">
                <span class="parent-phone-label">
                  {{ $t('attendanceAbsenceNotification.father') }}
                </span>
                <span>{{ record.father_phone }}</span>
              </div>
              <div v-if="record.mother_phone" class="parent-phone-line">
                <span class="parent-phone-label parent-phone-label-mother">
                  {{ $t('attendanceAbsenceNotification.mother') }}
                </span>
                <span>{{ record.mother_phone }}</span>
              </div>
              <span v-if="!record.father_phone && !record.mother_phone">-</span>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span :class="sentClass(record.is_sent)">
                {{ sentText(record.is_sent) }}
              </span>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a-popconfirm v-if="!record.is_sent" placement="leftTop"
                :title="$t('attendanceAbsenceNotification.confirmSend')" :ok-text="$t('yes')" :cancel-text="$t('no')"
                @confirm="send(record)">
                <a href="#" class="btn btn-primary btn-sm ts-whitespace-no-wrap"
                  :class="{ disabled: sendingLogId === record.log_id }" role="button">
                  <i class="fa fa-paper-plane mr-1"></i>
                  {{ $t('attendanceAbsenceNotification.send') }}
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FilterDrawer from './components/filter-drawer'

export default {
  name: 'attendanceAbsenceNotification',
  components: { FilterDrawer },
  data() {
    return {
      loading: false,
      filterLoading: false,
      visible: false,
      branchs: [],
      academicYears: [],
      mainPrograms: [],
      subPrograms: [],
      academicTerms: [],
      warningLevels: [],
      filters: this.emptyFilters(),
      sendingLogId: null
    }
  },
  created() {
    this.branch_id = [parseInt(this.$store.state.authUser.default_branch_id)]
    this.fetchData()
    this.getBranch()
    this.getFormViewModel()
  },
  computed: {
    ...mapState('attendanceAbsenceNotification', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.attendanceAbsenceNotification.search
      },
      set(newVal) {
        this.$store.commit('attendanceAbsenceNotification/SET_SEARCH', newVal)
        this.$store.commit('attendanceAbsenceNotification/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.attendanceAbsenceNotification.branch_id
      },
      set(newValue) {
        this.$store.commit(
          'attendanceAbsenceNotification/SET_BRANCH_ID',
          newValue
        )
      }
    },
    columns() {
      return [
        { name: this.$t('attendanceAbsenceNotification.branch') },
        { name: this.$t('attendanceAbsenceNotification.cardNumber') },
        { name: this.$t('attendanceAbsenceNotification.studentName') },
        { name: this.$t('attendanceAbsenceNotification.gender') },
        { name: this.$t('attendanceAbsenceNotification.term') },
        { name: this.$t('attendanceAbsenceNotification.session') },
        {
          name: this.$t('attendanceAbsenceNotification.absenceCount'),
          style: 'text-align:center'
        },
        {
          name: this.$t('attendanceAbsenceNotification.lastAbsentDate'),
          style: 'text-align:center'
        },
        {
          name: this.$t('attendanceAbsenceNotification.warningLevel'),
          style: 'text-align:center'
        },
        { name: this.$t('attendanceAbsenceNotification.teacher') },
        { name: this.$t('attendanceAbsenceNotification.parentPhones') },
        {
          name: this.$t('attendanceAbsenceNotification.status'),
          style: 'text-align:center'
        },
        {
          name: this.$t('attendanceAbsenceNotification.actions'),
          style: 'text-align:center'
        }
      ]
    }
  },
  methods: {
    emptyFilters() {
      return {
        ac_year_id: [],
        acp_id: [],
        acps_id: [],
        ac_term_id: [],
        warning_level_id: [],
        is_sent: 'pending'
      }
    },
    queryParams(attributes = {}) {
      const params = {
        branch_id: this.branch_id,
        ac_year_id: this.filters.ac_year_id,
        acp_id: this.filters.acp_id,
        acps_id: this.filters.acps_id,
        ac_term_id: this.filters.ac_term_id,
        warning_level_id: this.filters.warning_level_id,
        all_branch: Array.isArray(this.branch_id)
          ? this.branch_id.length
            ? undefined
            : true
          : true
      }
      const isSent = this.statusFilterValue()

      if (isSent !== undefined) {
        params.is_sent = isSent
      }

      return Object.assign(params, { ...attributes })
    },
    formViewModelParams() {
      return {
        branch_id: this.branch_id,
        all_branch: Array.isArray(this.branch_id)
          ? this.branch_id.length
            ? undefined
            : true
          : true
      }
    },
    statusFilterValue() {
      if (this.filters.is_sent === 'sent') {
        return 1
      }

      if (this.filters.is_sent === 'pending') {
        return 0
      }

      return undefined
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'attendanceAbsenceNotification/fetch',
          this.queryParams(attributes)
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getFormViewModel() {
      this.filterLoading = true

      return this.$store
        .dispatch(
          'attendanceAbsenceNotification/formViewModel',
          this.formViewModelParams()
        )
        .then(response => {
          this.academicYears = response.academic_years || []
          this.mainPrograms = response.main_programs || []
          this.subPrograms = response.sub_programs || []
          this.academicTerms = response.academic_terms || []
          this.warningLevels = response.warning_levels || []
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterLoading = false
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    changeBranchFilter(branchId) {
      this.branch_id = branchId
      this.filters = this.emptyFilters()
      this.getFormViewModel()
    },
    clearFilters() {
      this.branch_id = [this.$store.state.authUser.default_branch_id]
      this.filters = this.emptyFilters()
      this.getFormViewModel()
    },
    cancelFilters() {
      this.visible = false
    },
    applyFilters() {
      this.$store.commit('attendanceAbsenceNotification/RESET_CURRENT_PAGE')
      this.visible = false
      this.fetchData()
    },
    send(record) {
      this.sendingLogId = record.log_id
      this.$store
        .dispatch('attendanceAbsenceNotification/send', record.log_id)
        .then(response => {
          const data = response && response.data ? response.data : {}
          const message =
            data.messages || this.$t('attendanceAbsenceNotification.sent')

          if (Number(data.message_id) === 1) {
            this.$toasted.success(message)
            this.fetchData()
            return
          }

          this.$toasted.warning(message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.sendingLogId = null
        })
    },
    warningLevelClass(level) {
      if (level >= 3) {
        return 'warning-pill warning-pill-high'
      }

      if (level === 2) {
        return 'warning-pill warning-pill-medium'
      }

      return 'warning-pill warning-pill-low'
    },
    sentText(isSent) {
      return isSent
        ? this.$t('attendanceAbsenceNotification.sent')
        : this.$t('attendanceAbsenceNotification.pending')
    },
    sentClass(isSent) {
      return isSent ? 'status-pill status-sent' : 'status-pill status-pending'
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('attendanceAbsenceNotification/RESET_STATE')
    next()
  }
}
</script>

<style scoped>
.warning-pill,
.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  border-radius: 10px;
  color: #4b5563;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.warning-pill-high {
  color: #991b1b;
}

.warning-pill-medium {
  color: #92400e;
}

.warning-pill-low {
  color: #4b5563;
}

.parent-phone-cell {
  min-width: 160px;
}

.parent-phone-line {
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.6;
}

.parent-phone-label {
  display: inline-flex;
  justify-content: flex-start;
  min-width: 42px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
}

.parent-phone-label-mother {
  color: #6b7280;
}

.status-sent {
  color: #166534;
}

.status-pending {
  color: #92400e;
}
</style>
